import * as blUrls from 'lib/urls'
import { InfoButton } from 'components/buttons'
import Link from 'components/link'
import { HBB_QUALIFICATION_PURCHASE_AMOUNT } from 'shared/constants'

const PurchaseFromBabylistStore = () => {
  return (
    <div className="mvl">
      <p>
        Qualify for a free Hello Baby Box after you have over $
        {HBB_QUALIFICATION_PURCHASE_AMOUNT} of purchases from your registry (by
        yourself or others). Items must be from the{' '}
        <Link url={blUrls.storePath}>Babylist Shop</Link> to be eligible.
      </p>
      <InfoButton block className="mvm" href={blUrls.storePath}>
        Browse The Babylist Shop
      </InfoButton>
    </div>
  )
}

export default PurchaseFromBabylistStore
